import { DhlDropdown as NewSelect } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for DropdownField component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const DropdownField = (props) => {
  const { id, label, name, value, onChange, children, disabled, ...rest } =
    props;

  // Map old props to new props
  const newProps = {
    ...rest,
    id,
    label,
    name,
    value,
    isDisabled: disabled,
    onChange,
  };

  return <NewSelect {...newProps}>{children}</NewSelect>;
};

DropdownField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

export default DropdownField;
